import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/system-settings` 
  : 'https://backend-c-0mxm.onrender.com/api/system-settings';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    try {
      const userData = localStorage.getItem('user');
      if (userData) {
        const user = JSON.parse(userData);
        if (user.userId || user.token) {
          config.headers.Authorization = `Bearer ${user.userId || user.token}`;
        }
      }
    } catch (error) {
      console.warn('Error parsing user data from localStorage:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const handleError = (error) => {
  if (error.response) {
    return {
      message: error.response.data.message || 'Có lỗi xảy ra từ server',
      status: error.response.status,
    };
  } else if (error.request) {
    return {
      message: 'Không thể kết nối đến server',
      status: 0,
    };
  } else {
    return {
      message: 'Có lỗi xảy ra khi tạo request',
      status: 0,
    };
  }
};

// Get system setting by key
export const getSystemSetting = async (key) => {
  try {
    const response = await api.get(`/${key}`);
    return {
      success: true,
      data: response.data.data
    };
  } catch (error) {
    return {
      success: false,
      error: handleError(error)
    };
  }
};

// Set system setting (admin only)
export const setSystemSetting = async (key, value, description = '') => {
  try {
    const response = await api.post(`/${key}`, { value, description });
    return {
      success: true,
      data: response.data.data,
      message: response.data.message
    };
  } catch (error) {
    return {
      success: false,
      error: handleError(error)
    };
  }
};

// Get all system settings (admin only)
export const getAllSystemSettings = async () => {
  try {
    const response = await api.get('/');
    return {
      success: true,
      data: response.data.data
    };
  } catch (error) {
    return {
      success: false,
      error: handleError(error)
    };
  }
};

